import { render, staticRenderFns } from "./TagSummary.vue?vue&type=template&id=0913ec8b&scoped=true&"
import script from "./TagSummary.vue?vue&type=script&lang=js&"
export * from "./TagSummary.vue?vue&type=script&lang=js&"
import style0 from "./TagSummary.vue?vue&type=style&index=0&id=0913ec8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0913ec8b",
  null
  
)

export default component.exports